import React from 'react';

const STATS = [
    { num: '2,000+', label: 'Founders, investors & advisors' },
    { num: '80%+', label: 'Members with 3+ live relationships' },
    { num: '3', label: 'Ways to connect — Investor, Advisor, Partner, Company' },
    { num: '1', label: 'Community that shows up in person' },
];

const CommunityStatsSection = () => (
    <section className="lp-cm-stats">
        <div className="lp-cm-stats-inner">
            <div className="lp-cm-stats-head" data-lp-reveal>
                <img className="lp-cm-stats-logo" src={require('../../../../images/landing-pages/community/su2su-logo.webp')} alt="Startup 2 Standup" />
                <div className="lp-cm-stats-note">The numbers below reflect our partner community, Startup 2 Standup.</div>
            </div>
            <div className="lp-cm-stats-grid">
                {STATS.map((s, i) => (
                    <div key={s.num + i} data-lp-reveal data-lp-delay={i * 80}>
                        <b>{s.num}</b>
                        <span>{s.label}</span>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default CommunityStatsSection;
